import { render, staticRenderFns } from "./PlayerList.vue?vue&type=template&id=3ebf861f&scoped=true"
import script from "./PlayerList.vue?vue&type=script&lang=js"
export * from "./PlayerList.vue?vue&type=script&lang=js"
import style0 from "./PlayerList.vue?vue&type=style&index=0&id=3ebf861f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf861f",
  null
  
)

export default component.exports